import {
  CREATE_GROUP,
  GET_GROUPS,
  GET_GROUP_DETAILS,
  SET_UPLOAD_MSG,
} from '../../actions/groups';
import { groupUploadMsg } from '../../pages/common/components/constants';

const groupsReducer = (state = {}, action = {}) => {
  const {
    type = '',
    groupsData = {},
    groupData = {},
    newGroup = {},
    uploadMsg = groupUploadMsg,
  } = action;
  switch (type) {
    case CREATE_GROUP.INITIATE: {
      return {
        ...state,
      };
    }
    case CREATE_GROUP.SUCCESS: {
      return {
        ...state,
        processId: newGroup,
      };
    }
    case CREATE_GROUP.FAILED:
      return {
        ...state,
      };
    case CREATE_GROUP.CLEAR:
      return {
        ...state,
        processId: '',
        uploadMsg: groupUploadMsg,
      };
    case SET_UPLOAD_MSG:
      return {
        ...state,
        uploadMsg,
      };
    case GET_GROUPS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_GROUPS.SUCCESS:
      return {
        ...state,
        ...groupsData,
      };
    case GET_GROUPS.FAILED:
      return {
        ...state,
      };
    case GET_GROUP_DETAILS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_GROUP_DETAILS.SUCCESS:
      return {
        ...state,
        groupData,
      };
    case GET_GROUP_DETAILS.FAILED:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default groupsReducer;
